
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4l.375.156L23 6.812v6.719l5.406 2.344.594.281v8.063l-.5.313-6 3.344-.469.25-.469-.219-5.563-2.781-5.563 2.781-.469.219-.469-.25-6-3.344-.5-.313v-8.063l.594-.281 5.406-2.344V6.812l6.625-2.656zm0 2.188l-3.281 1.281L16 8.75l3.281-1.281zm-5 2.75v4.625l4 1.781v-4.875zm10 0l-4 1.531v4.875l4-1.781V8.938zm-11 6.375l-3.625 1.563L10 18.689l3.625-1.781zm12 0l-2.5 1.094-1.125.5L22 18.688l3.625-1.813zM5 18.406v4.656l4 2.25v-4.906zm22 0l-4 2v4.906l4-2.25v-4.656zm-12 .063l-4 1.938v4.969l4-2V18.47zm2 0v4.906l4 2v-4.969z"}})])
          )
        }
      }
    